import React from 'react';
import { Button } from './ui/button';
import { ChevronDown } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const HeroSection = () => {
  const navigate = useNavigate();
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-[#1a1c1b]" data-testid="hero-section">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <div className="absolute w-full h-full">
          <img
            src="https://images.pexels.com/photos/1295036/pexels-photo-1295036.jpeg?auto=compress&cs=tinysrgb&w=1920"
            alt="Yacht professionnel"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#000000]/90 via-[#000000]/70 to-transparent"></div>
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-[87.5rem] mx-auto px-5 md:px-10 py-32 md:py-40">
        <div className="max-w-3xl">
          <h1 className="font-black text-6xl md:text-8xl leading-[0.85] text-[#d9fb06] uppercase mb-8">
            Achetez votre bateau en toute confiance
          </h1>

          <p className="text-xl md:text-2xl text-[#d9fb06] font-medium mb-4 leading-relaxed">
            Aide à construire un achat serein
          </p>

          <p className="text-lg md:text-xl text-[#888680] font-medium mb-12 leading-relaxed max-w-xl">
            Expert nautique indépendant | 30 ans d&apos;expérience dans la vente | Propriétaire de plusieurs bateaux | Basé à La Rochelle
          </p>

          <div className="space-y-4 mb-12">
            <div className="flex items-start space-x-3">
              <div className="w-2 h-2 bg-[#d9fb06] rounded-full mt-2 flex-shrink-0"></div>
              <p className="text-[#dfddd6] text-lg">Envie d&apos;acheter en toute sérénité, sans mauvaise surprise&nbsp;?</p>
            </div>
            <div className="flex items-start space-x-3">
              <div className="w-2 h-2 bg-[#d9fb06] rounded-full mt-2 flex-shrink-0"></div>
              <p className="text-[#dfddd6] text-lg">Pas le temps de chercher le bon bateau&nbsp;?</p>
            </div>
            <div className="flex items-start space-x-3">
              <div className="w-2 h-2 bg-[#d9fb06] rounded-full mt-2 flex-shrink-0"></div>
              <p className="text-[#dfddd6] text-lg">Besoin d&apos;un avis expert avant d&apos;acheter&nbsp;?</p>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-3xl">
            <Button
              onClick={() => scrollToSection('contact')}
              data-testid="hero-contact-btn"
              className="w-full h-auto min-h-[64px] whitespace-normal text-center bg-[#d9fb06] text-[#1a1c1b] hover:bg-[#d9fb06]/90 rounded-full px-6 py-4 text-base font-bold uppercase transition-all hover:scale-105 shadow-lg"
            >
              Réserver un appel gratuit
            </Button>
            <Button
              onClick={() => navigate('/analyse-annonce-bateau')}
              data-testid="hero-analyse-btn"
              className="w-full h-auto min-h-[64px] whitespace-normal text-center bg-transparent text-[#d9fb06] border-2 border-[#d9fb06] hover:bg-[#d9fb06] hover:text-[#1a1c1b] rounded-full px-6 py-4 text-base font-bold uppercase transition-all hover:scale-105"
            >
              Analyser une annonce
            </Button>
            <Button
              onClick={() => scrollToSection('services')}
              data-testid="hero-services-btn"
              className="w-full h-auto min-h-[64px] whitespace-normal text-center bg-transparent text-[#d9fb06] border-2 border-[#d9fb06] hover:bg-[#d9fb06] hover:text-[#1a1c1b] rounded-full px-6 py-4 text-base font-bold uppercase transition-all hover:scale-105"
            >
              Découvrir nos services
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <ChevronDown className="text-[#d9fb06]" size={32} />
      </div>
    </section>
  );
};

export default HeroSection;
